<template>
  <div class="batchList">
    <SectionTitleBar :sectionLinks="availableViews" :buttonText="'Filter'"/>
    <table class="adminUserTable">
      <thead>
        <tr>
          <th v-for="field in fields" :key="field.key">{{field.label}}</th>
        </tr>
      </thead>
      <tbody>
        <FirebaseRow v-for="batch in deliveryBatches" :record="batch" :fields="fields" :key="batch.id" :collection="'batches'"/>
        <tr>
          <td colspan="4"><button v-on:click="addNewBatch">Add New</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FirebaseRow from '../components/FirebaseRow.vue'
import SectionTitleBar from '../components/SectionTitleBar.vue'

export default {
  name: 'batchList',
  components: {
    FirebaseRow,
    SectionTitleBar
  },
  data () {
    return {
      selectedView: "list",
      viewLinks: [
        {
          "name": "List",
          "admin": true,
          "viewName": "list"
        }
      ],
    }
  },
  computed: {
    deliveryBatches () {
      return this.$store.getters.batchArray;
    },
    availableViews(){
      var visibleViews = []
      var existingRoute = this.$route
      var selectedView = this.selectedView
      this.viewLinks.forEach((link) => {
        var linkRoute = {
          ...existingRoute,
          query: {
            ...existingRoute.query,
            view: link.viewName
          }
        }
        visibleViews.push({
          ...link,
          route: linkRoute,
          selected: (selectedView === link.viewName)
        })
      })
      return visibleViews
    },
    fields () {
      return [
        {
          "label": "Batch Name",
          "key": "name",
          "type": "String",
          "editable": true
        },
        {
          "label": "Delivery Date",
          "key": "deliveryDate",
          "type": "Date",
          "editable": true
        }
      ]
    }
  },
  methods: {
    addNewBatch () {
      this.$store.dispatch('createNewBatch')
    }
  }
}
</script>

<style>
  .groupName {
    text-align: center;
  }
  .batchList {
    width: 100%;
    height: 100%;
  }
  .adminUserTable {
    width: 100%;
    text-align: left;
    border-collapse: collapse;
  }
  td {
    border: 2px solid #2E303A;
  }
  td, th {
    padding: 15px;
  }
</style>
